import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { TemplatesService } from '@core/services/templates.service';
import { TemplatesEditComponent } from '@modules/templates/templates-edit/templates-edit.component';
import { Constants } from '@shared/class/constants.class';
import { Template } from '@shared/interfaces/template';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-templates-list',
  templateUrl: './templates-list.component.html'
})
export class TemplatesListComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public location = 'templates';
  public dataSource: MatTableDataSource<Template>;
  public selection = new SelectionModel<Template>(true, []);
  public templatesList: Array<Template> = [];
  public template: Template;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filterInput: ElementRef;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public templatesService: TemplatesService
  ) {
    this.constants.displayedColumns = [
      this.appConfig.ACTIONS.delete.id,
      'id',
      'name',
      'value',
      'idType',
      'type',
      this.appConfig.ACTIONS.edit.id
    ];
    const result = this.generalsService.getActions(
      this.constants.displayedColumns,
      this.constants.actionsList,
      this.location
    );

    this.constants.displayedColumns = result.displayedColumns;
    this.constants.displayedActions = result.displayedActions;
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  loadData() {
    this.constants.loading = true;
    this.constants.elements = true;
    this.templatesService
      .getItems()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(
        result => {
          this.templatesList = [];
          result.data.forEach((element: any) => {
            this.template = {
              id: element.id,
              name: element.attributes.name,
              value: element.attributes.value,
              idType: element.relationships.type.id,
              type: element.relationships.type.name
            };
            this.templatesList.push(this.template);
          });
          if (this.templatesList.length) {
            this.dataSource = new MatTableDataSource(this.templatesList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.constants.filter = this.dataSource.filteredData;
            this.selection.clear();
          } else {
            this.constants.elements = false;
          }

          this.constants.error = false;
          this.constants.loading = false;
        },
        error => {
          this.constants.errorText = this.generalsService.showError(error);
          this.constants.error = true;
          this.constants.loading = false;
        }
      );
  }

  reload() {
    this.generalsService.reload(this);
  }

  edit(action: string, item?: Template) {
    let dialog: any;

    const data = {
      action: action,
      item: {}
    };

    if (action === this.appConfig.ACTIONS.add.id) {
      this.constants.message = this.appConfig.LANG.message.addSuccess;
    } else {
      data.item = item;
      this.constants.message = this.appConfig.LANG.message.editSuccess;
    }

    dialog = this.generalsService.modal(
      TemplatesEditComponent,
      data,
      'mat-modal-big'
    );

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.generalsService.afterClosed(this, result, this.constants.message);
      });
  }

  delete() {
    const selected = this.selection.selected,
      selectedLength = this.selection.selected.length,
      dataLength = this.dataSource.data.length;

    let dialog: any;

    this.constants.message = this.generalsService.messageSelectedDelete(
      'confirm',
      selectedLength,
      dataLength
    );

    dialog = this.generalsService.alert(this.constants.message);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result === 200) {
          this.generalsService.delete(
            selected,
            selectedLength,
            dataLength,
            this.templatesService
          );
          this.generalsService.delete$
            .pipe(takeUntil(this.constants.destroy$))
            .subscribe(deleteResult => {
              if (deleteResult) {
                this.reload();
              }
            });
        }
      });
  }

  selectDelete() {
    const numSelected = this.selection.selected.length,
      numRows = this.dataSource.data.length;

    this.constants.labelDelete = this.generalsService.messageSelectedDelete(
      'label',
      numSelected,
      numRows
    );
  }

  filterData(event: any) {
    this.generalsService.applyFilter(this.dataSource, event);
    this.constants.filter = this.dataSource.filteredData;
  }
}
